import { $Deck } from '../__generated/enhanced-model.js';
import { MetalPostStyleType, PostShapeType, PostType } from '../__generated/model/index.js';
import { DataBindingBuilder } from '../sdk/data-binding.js';
const finishSwatches = DataBindingBuilder.fromConstant({
    value: {
        Bright: {
            swatchName: 'Bright Finish',
            thumbnailUrl: '/images/swatches/metalBright.jpg',
            color: '#e7e7e7'
        },
        BlackEtch: {
            swatchName: 'Black Etch',
            thumbnailUrl: '/images/swatches/metalBlackEtch.jpg',
            color: '#423f43'
        }
    }
});
const thinIntermediatePostSwatches = DataBindingBuilder.fromConstant({
    value: {
        SatinStainless: {
            swatchName: 'Satin Finish',
            thumbnailUrl: '/images/swatches/metalSatin.jpg',
            color: '#b4bdc7'
        },
        MirrorStainless: {
            swatchName: 'Mirror Polish',
            thumbnailUrl: '/images/swatches/metalMirrorPolish.jpg',
            color: '#f0f2f4'
        },
        BlackAlu: {
            swatchName: 'Black Aluminium',
            thumbnailUrl: '/images/swatches/aluminiumBlack.jpg',
            color: '#000000'
        }
    }
});
const postStyle = DataBindingBuilder.from('postStyle', $Deck, [
    'postStyle'
], [
    {
        keys: {
            postStyle: MetalPostStyleType.Custom
        },
        values: {
            isStainless: false
        }
    },
    {
        keys: {
            postStyle: MetalPostStyleType.RoundStainless
        },
        values: {
            isStainless: true
        }
    },
    {
        keys: {
            postStyle: MetalPostStyleType.SquareStainless
        },
        values: {
            isStainless: true
        }
    },
    {
        keys: {
            postStyle: MetalPostStyleType.SquareAlu
        },
        values: {
            isStainless: false
        }
    }
]);
const postShape = DataBindingBuilder.from('postShape', $Deck, [
    'postType',
    'postStyle'
], [
    {
        keys: {
            postType: PostType.Timber,
            postStyle: MetalPostStyleType.values()
        },
        values: {
            postShape: PostShapeType.Square
        }
    },
    {
        keys: {
            postType: PostType.Metal,
            postStyle: MetalPostStyleType.Custom
        },
        values: {
            postShape: PostShapeType.Custom
        }
    },
    {
        keys: {
            postType: PostType.Metal,
            postStyle: MetalPostStyleType.SquareAlu
        },
        values: {
            postShape: PostShapeType.Square
        }
    },
    {
        keys: {
            postType: PostType.Metal,
            postStyle: MetalPostStyleType.SquareStainless
        },
        values: {
            postShape: PostShapeType.Square
        }
    },
    {
        keys: {
            postType: PostType.Metal,
            postStyle: MetalPostStyleType.RoundStainless
        },
        values: {
            postShape: PostShapeType.Round
        }
    }
]);
export const DeckDataBindings = {
    finishSwatches,
    thinIntermediatePostSwatches,
    postStyle,
    postShape
};

//# sourceMappingURL=deck.js.map